import * as angular from "angular";

angular
  .module('bringoz.admin.customers')
  .constant('Customers_PN', {
    database: 'customers',
    isBranchEntity: false
  });
